var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14218",
    "data-name": "Group 14218",
    transform: "translate(-88 -117)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13700",
    "data-name": "Group 13700",
    transform: "translate(76 105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13051",
    "data-name": "Path 13051",
    d: "M30,0A30,30,0,1,1,0,30,30,30,0,0,1,30,0Z",
    transform: "translate(12 12)",
    fill: "#dcdcdc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14073",
    "data-name": "Group 14073",
    transform: "translate(108 137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13137",
    "data-name": "Path 13137",
    d: "M0,0H2V20H0Z",
    transform: "translate(9)",
    fill: "#868a97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2978",
    "data-name": "Rectangle 2978",
    width: 2,
    height: 20,
    transform: "translate(20 9) rotate(90)",
    fill: "#868a97"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.5720db762f4ba7d4f55b56b5dc6e7b16.svg";
export { ForwardRef as ReactComponent };